<template>
  <div class="linechart" ref="lineChart" style="width: 90%; height: 90%;justify-content: center;align-items: center;padding-bottom: 100px;"></div>
</template>

<script>
import * as echarts from 'echarts';
import { defineComponent, onMounted, ref } from 'vue';

export default defineComponent({
  name: 'LineChart',
  setup() {
    const lineChart = ref(null);

    onMounted(() => {
      const chart = echarts.init(lineChart.value);
      const dates = ['2024-10-01', '2024-10-02', '2024-10-03', '2024-10-04', '2024-10-05', '2024-10-06', '2024-10-07'];
      const hours = [10, 15, 13, 18, 12, 11, 16]; // 示例数据

      const option = {
        tooltip: {
					trigger: 'axis',
          // 添加以下样式来限制宽度并允许换行
          extraCssText: 'max-width: 180px; white-space: normal;'
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true,
          backgroundColor: {
            type: 'linear',
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [
              {
                offset: 0, color: '#1fdbff' // 渐变色的起始颜色
              },
              {
                offset: 1, color: '#6f42fb' // 渐变色的结束颜色
              }
            ],
            global: false // 缺省为 false
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: dates,
          name: '日期',
          nameLocation: 'end', // 将单位显示在x轴的末端
          nameTextStyle: { // 单位的样式
            padding: [0, 0, 0, 20] // 上右下左的内边距
          }
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            formatter: '{value} 小时'
          },
          name: '小时',
          nameLocation: 'end', // 将单位显示在y轴的末端
          nameTextStyle: { // 单位的样式
            padding: [0, 20, 0, 0] // 上右下左的内边距
          },
          interval: 5, // 设置y轴的间隔为5
        },
        series: [
          {
            name: '平台使用时间',
            type: 'line',
            smooth: true, // 开启平滑曲线
            data: hours,
            itemStyle: {
              color: '#ff6347' // 点的颜色
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(
                0, 0, 0, 1,
                [
                  {offset: 0, color: '#daebff'},
                  {offset: 1, color: '#ffffff'}
                ]
              )
            },
            lineStyle: {
              width: 2,
              color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
                offset: 0,
                color: '#1fdbff' // 渐变色的起始颜色
              }, {
                offset: 1,
                color: '#6f42fb' // 渐变色的结束颜色
              }]), // 渐变色的设置
            }
          }
        ]
      };
      chart.setOption(option);
    });

    return {
      lineChart
    };
  }
});
</script>

<style>
.linechart>canvas{
  width: 90% !important;
}
.linechart>div{
  width: 100% !important;
}
</style>